import React, { useState } from "react";
import { BootstrapModal } from "../BootstrapModal/Modal";
import { CgClose } from "react-icons/cg";
import Button from "../Button/Button";
import { InputField1 } from "../InputField1/InputField1";
import { SimpleTextArea } from "../SimpleTextArea/SimpleTextArea";
import styled from "styled-components";
import { useEffect } from "react";
import { useGetShowSeo, useGetUpdateBrandSeo } from "../../hooks/useContent";
import Loading from "../Loadings/LoadingTable";
const initValue = {
  TitleSeo: null,
  IdRefrenceSeo: null,
  locationSeo: "Brand",
  EnTitleSeo: null,
  ArTitleSeo: null,
  KeywordSeo: null,
  EnKeywordSeo: null,
  ArKeywordSeo: null,
  DescriptionSeo: null,
  EnDescriptionSeo: null,
  ArDescriptionSeo: null,
  CanonicalTagSeo: null,
  Redirect3xx: null,
};
export const EditBrandSeoModal = ({ show, handleClose, item }) => {
  const [button] = useState(false);
  const [form, setForm] = useState(initValue);
  const { mutateAsync: updateSeo } = useGetUpdateBrandSeo();
  const { data, isLoading } = useGetShowSeo({
    locationSeo: "Brand",
    IdRefrenceSeo: item?.IdBrands,
  });
  const handleUpdate = async (data) => {
    await updateSeo(data).then();
  };
  const seo = data?.data?.seos[0] ? data?.data?.seos[0] : null;

  useEffect(() => {
    if (seo !== "Null") {
      setForm({
        ...form,
        TitleSeo: seo?.NameShopForSeo,
        EnTitleSeo: seo?.NameShopForSeoEnglish,
        ArTitleSeo: seo?.NameShopForSeoLanguage,
        KeywordSeo: seo?.KeywordShopForSeo,
        EnKeywordSeo: seo?.KeywordShopForSeoEnglish,
        ArKeywordSeo: seo?.KeywordShopForSeoLanguage,
        DescriptionSeo: seo?.DescriptionShopForSeo,
        EnDescriptionSeo: seo?.DescriptionShopForSeoEnglish,
        ArDescriptionSeo: seo?.DescriptionShopForSeoLanguage,
        CanonicalTagSeo: seo?.CanonicalTagSeo,
        Redirect3xx: seo?.Redirect3xx,
        IdRefrenceSeo: item?.IdBrands,
      });
    } else {
      setForm(initValue);
    }
  }, [seo]);

  return (
    <BootstrapModal
      modaltitle="ویرایش و درج سئو برند"
      handleClose={() => {
        handleClose();
      }}
      show={show}
      moreButton={button}
      size="md"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      {!isLoading ? (
        <UpdateSeoStyle>
          <div className="row p-0 m-0">
            <InputField1
              name={"TitleSeo"}
              onChange={(e) => setForm({ ...form, TitleSeo: e.target.value })}
              value={form.TitleSeo}
              label={"عنوان"}
            />
            <InputField1
              name={"EnTitleSeo"}
              onChange={(e) => setForm({ ...form, EnTitleSeo: e.target.value })}
              value={form.EnTitleSeo}
              label={"عنوان انگلیسی"}
            />
            <InputField1
              name={"ArTitleSeo"}
              onChange={(e) => setForm({ ...form, ArTitleSeo: e.target.value })}
              value={form.ArTitleSeo}
              label={"عنوان عربی"}
            />
            <InputField1
              name={"KeywordSeo"}
              onChange={(e) => setForm({ ...form, KeywordSeo: e.target.value })}
              value={form.KeywordSeo}
              label={"کلمات "}
            />
            <InputField1
              name={"EnKeywordSeo"}
              onChange={(e) =>
                setForm({ ...form, EnKeywordSeo: e.target.value })
              }
              value={form.EnKeywordSeo}
              label={"کلمات انگلیسی"}
            />
            <InputField1
              name={"ArKeywordSeo"}
              value={form.ArKeywordSeo}
              onChange={(e) =>
                setForm({ ...form, ArKeywordSeo: e.target.value })
              }
              label={"کلمات عربی"}
            />
            <SimpleTextArea
              name={"DescriptionSeo"}
              value={form.DescriptionSeo}
              onChange={(e) =>
                setForm({ ...form, DescriptionSeo: e.target.value })
              }
              label={"توضیحات فارسی"}
              rows={4}
            />
            <SimpleTextArea
              name={"EnDescriptionSeo"}
              onChange={(e) =>
                setForm({ ...form, EnDescriptionSeo: e.target.value })
              }
              value={form.EnDescriptionSeo}
              label={"توضیحات انگلیسی"}
              rows={4}
            />
            <SimpleTextArea
              name={"ArDescriptionSeo"}
              label={"توضیحات عربی"}
              value={form.ArDescriptionSeo}
              onChange={(e) =>
                setForm({ ...form, ArDescriptionSeo: e.target.value })
              }
              rows={4}
            />
            <InputField1
              name={"CanonicalTagSeo"}
              onChange={(e) =>
                setForm({ ...form, CanonicalTagSeo: e.target.value })
              }
              value={form.CanonicalTagSeo}
              label={"تگ"}
            />
            <InputField1
              name={"Redirect3xx"}
              value={form.Redirect3xx}
              onChange={(e) =>
                setForm({ ...form, Redirect3xx: e.target.value })
              }
              label={"Redirect3xx"}
            />
          </div>
        </UpdateSeoStyle>
      ) : (
        <Loading />
      )}
      <div className="row">
        <div className="col-6">
          <Button
            bgColor="#009EF7"
            color="#fff"
            onclick={() => {
              handleUpdate(form);
              handleClose();
            }}
          >
            تایید
          </Button>
        </div>
        <div className="col-6">
          <Button bgColor="#F1416C" color="#fff" onclick={handleClose}>
            لغو
          </Button>
        </div>
      </div>
    </BootstrapModal>
  );
};
const UpdateSeoStyle = styled.div`
  height: 40vh;
  background-color: #fff;
  overflow-y: scroll;
`;
